import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "ui/components/dialog";
import { Button } from "ui/components/button";
import ButtonWithLoading from "@/components/button-with-loading";

export default function ReviewAlert({
  open,
  onOpenChange,
  onConfirm,
  isLoading,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogDescription>
            This will approve all logged hours in this card. Are you sure you
            want to proceed?{" "}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <ButtonWithLoading
            variant="default"
            isLoading={isLoading}
            onClick={onConfirm}
          >
            Yes, Approve All
          </ButtonWithLoading>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
